import "font-awesome/css/font-awesome.min.css";
import "@fortawesome/fontawesome-free/css/fontawesome.min.css";
import { Route, Switch } from "react-router";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import NotFound from "../../shared/not-found/notFound";
import ControlledRoute from "../../security/controlledRoute";
import { getEffectiveRoutes } from "../../security/route";
import AccueilLayout from "./layout/layout";
import { routes } from "./route/routes";
import "react-vertical-timeline-component/style.min.css";

const DASHBOARD_ROUTING_ANIMATION = "fadeup";

const Dashboard: React.FC = () => {
  return (
    <AccueilLayout>
      <TransitionGroup>
        <Switch>
          {getEffectiveRoutes(routes).map(({ path, Component, exact, roles }) => (
            <ControlledRoute key={path} exact={exact} path={`${path}`} roles={roles}>
              <CSSTransition in={true} timeout={0} classNames={DASHBOARD_ROUTING_ANIMATION} unmountOnExit>
                <div>
                  <Component />
                </div>
              </CSSTransition>
            </ControlledRoute>
          ))}
          <Route component={NotFound} />
        </Switch>
      </TransitionGroup>
    </AccueilLayout>
  );
};

export default Dashboard;
